import { defineComponent as A, useAttrs as k, createBlock as C, openBlock as t, unref as n, withCtx as y, createElementVNode as i, mergeProps as w, createElementBlock as r, createCommentVNode as l, normalizeClass as s, renderSlot as a } from "vue";
import { RevListItemBase as B } from "@ds/components/ListItemBase";
const I = /* @__PURE__ */ A({
  name: "RevListItemStatic",
  inheritAttrs: !1,
  __name: "ListItemStatic",
  props: {
    wrapperAttrs: { default: () => ({}) },
    mainAreaClassNames: { type: [String, Boolean, Array, Object], default: "" }
  },
  setup(o) {
    const m = k();
    return (e, N) => (t(), C(n(B), { "wrapper-attrs": o.wrapperAttrs }, {
      default: y(({
        wrapperClassNames: p,
        prefixClassNames: d,
        descriptionClassNames: c,
        labelClassNames: f,
        suffixClassNames: u,
        mainAreaClassNames: v,
        titleClassNames: $
      }) => [
        i("div", w(n(m), { class: p }), [
          e.$slots.prefix ? (t(), r("div", {
            key: 0,
            class: s(d)
          }, [
            a(e.$slots, "prefix")
          ], 2)) : l("", !0),
          i("div", {
            class: s([v, o.mainAreaClassNames])
          }, [
            e.$slots.title ? (t(), r("div", {
              key: 0,
              class: s($)
            }, [
              a(e.$slots, "title")
            ], 2)) : l("", !0),
            i("div", {
              class: s(["text-static-default-hi", f])
            }, [
              a(e.$slots, "label")
            ], 2),
            e.$slots.description ? (t(), r("div", {
              key: 1,
              class: s(c)
            }, [
              a(e.$slots, "description")
            ], 2)) : l("", !0)
          ], 2),
          e.$slots.suffix ? (t(), r("div", {
            key: 1,
            class: s(u)
          }, [
            a(e.$slots, "suffix")
          ], 2)) : l("", !0)
        ], 16)
      ]),
      _: 3
    }, 8, ["wrapper-attrs"]));
  }
});
export {
  I as default
};
